angular.module('app.filters')
.filter('dashStatus', function($filter) {
    return function(input) {
        // Replace the underscores with spaces
        return input.replace(/_/g,' ');
    };
})
.filter('dashAccessibility', () =>
    function(input) {
        const tags = [];
        if (input.is_ticketed && input.free_variant === "low") { tags.push('flex') }
        else if (input.is_ticketed) { tags.push('ticketed'); }
        if (input.is_private) { tags.push('private'); }
        if (tags.length > 0) {
            return tags.join(', ');
        } else {
            return 'public';
        }
    }
);


// WEBPACK FOOTER //
// ./views/dashboard/dashboard_filters.js